import { Row, Col, Image } from "react-bootstrap";
import { useState } from "react";
// import Zoom from "react-medium-image-zoom";
import ReactImageZoom from 'react-image-zoom';


export default function ImagesWithPreview(props) {
  // big image on the right, (small) image previews to its left
  // big image has zoom functionality  

  const [selectedImage, setSelectedImage] = useState(props?.images[0] || []);

  if (!props?.images) {
    return;
  }

  return (
    <Row style={{display: "flex", justifyContent: "center"}}>
      {props?.images.length > 1 && (
        <Col xs={3} lg={2} >
          {props?.images.map((image, idx) => {
            return (
              <div key={idx}>
                <Image
                  key={idx}
                  onClick={() => setSelectedImage(image)}
                  className="mt-2"
                  fluid
                  thumbnail
                  src={image?.url}
                  style={{maxHeight: "60px"}}
                />
              </div>
            );
          })}
        </Col>
      )}
      <Col style={{ zIndex: 1 }} xs={9} lg={10}>
        <Row>
          <Col>
            <div
              id="bigImage"
              style={{
                padding: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >



            
<ReactImageZoom height={300} img={selectedImage?.url} zoomHeight={500} zoomWidth={450} zoomStyle='background-color: var(--bs-body-bg); border-radius:10px' zoomPosition="bottom" />
              {/* <Zoom zoomMargin={200} > */}
                {/* <Image
                  fluid
                  src={selectedImage?.url}
                  style={{maxHeight: "300px"}}
                ></Image> */}
              {/* </Zoom> */}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
